import React, { useContext } from 'react';
import { ProjectContext } from './ProjectContext';
import { FaPlus } from 'react-icons/fa';

const ReadProjects = ({ setCurrentView }) => {
  const { projects, loading, error: errorMessage, setSelectedProject } = useContext(ProjectContext);

  const getFirstContent = (description) => {
    if (!Array.isArray(description) || description.length === 0) {
      return 'No description available';
    }
    const firstContent = description.find(
      (block) => block?.content && typeof block.content === 'string' && block.content.trim() !== ''
    );
    return firstContent?.content || 'No description available';
  };

  if (loading) return <p className="text-center text-gray-600">Loading...</p>;
  if (errorMessage) return <p className="text-center text-red-600">{errorMessage}</p>;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-6xl font-extralight text-gray-700 pl-8">
          Project List
        </h2>
        <button
          onClick={() => setCurrentView('create')}
          className="flex items-center px-6 py-3 bg-blue-500 text-white font-medium rounded-lg hover:bg-blue-600 transition-all duration-200"
        >
          <FaPlus className="mr-2" />
          Create New Project
        </button>
      </div>
      <div className="bg-white p-8 rounded-lg">
        {projects.length === 0 ? (
          <p className="text-center text-gray-600">No projects found.</p>
        ) : (
          <ul className="space-y-4">
            {projects.map((project) => (
              <li key={project.id} className="p-4 border rounded-lg border-gray-300">
                <h3 className="text-xl font-medium text-gray-900">{project.title}</h3>
                <p className="text-gray-600 line-clamp-2">{getFirstContent(project.description)}</p>
                <div className="flex gap-4 mt-4">
                  <button
                    onClick={() => {
                      setSelectedProject(project);
                      setCurrentView('update');
                    }}
                    className="text-blue-600 hover:text-blue-800"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => {
                      setSelectedProject(project);
                      setCurrentView('delete');
                    }}
                    className="text-red-600 hover:text-red-800"
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default ReadProjects;